module.exports = __webpack_public_path__ + "static/Gotham Book Regular-a563635d2c187f9399dce23d8f00d585.otf";